<div style="transition: all 2s linear">
    <div class="d-sm-block d-flex">
        <mat-radio-group  class="max-loan-amount" [(ngModel)]="maxAmountSelected">
            <ng-container *ngFor="let maxAmountOption of maxAmountOptions;let i=index">
                <div class="max-amount-option col-sm-4 col-xs-12 col-12 col-xs-12 p-0 pb-2" [ngClass]="{'pl-0': i === 0}">
                    <mat-radio-button color="primary" [value]="maxAmountOption"
                        (change)="setCustomPortfolioPreference(maxAmountOption, $event)">
                        <span class="font-weight-normal text-wrap-balance"> {{ maxAmountOption }}% of portfolio amount</span>
                    </mat-radio-button>
                </div>
            </ng-container>
        </mat-radio-group>
    </div>
</div>